import { ChangeDetectionStrategy, Component, inject, Signal } from '@angular/core';

import { ChurnFlowReasonInfoboxService } from '@core/churn-flow-logic';
import { ChurnFlowSolutionCardI, ChurnReason } from '@core/churn-flow-types';
import {
  ChurnFlowReasonTemplateComponent,
  ChurnFlowSolutionCardComponent,
  ChurnFlowStepTemplateComponent,
} from '@core/churn-flow-ui';
import { TranslatePipe } from '@core/i18n-legacy';
import { ButtonComponent, IconComponent } from '@core/user-interface-legacy';

import { ChurnFlowInsightsComponent } from '../../components/churn-flow-insights/churn-flow-insights.component';
import { ChurnFlowReasonBaseComponent } from '../../components/churn-flow-reason-base.component';

@Component({
  selector: 'tlc-churn-too-complicated-page',
  templateUrl: './churn-too-complicated-page.component.html',
  styleUrls: ['./churn-too-complicated-page.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonComponent,
    ChurnFlowInsightsComponent,
    ChurnFlowReasonTemplateComponent,
    ChurnFlowSolutionCardComponent,
    ChurnFlowStepTemplateComponent,
    IconComponent,
    TranslatePipe,
  ],
})
export class ChurnTooComplicatedPageComponent extends ChurnFlowReasonBaseComponent {
  protected readonly reason = ChurnReason.TooComplicated;
  public readonly infoboxMessage: Signal<string | undefined> = inject(
    ChurnFlowReasonInfoboxService,
  ).getReasonInfoboxMessage(ChurnReason.TooComplicated);

  public readonly bookConsultation: ChurnFlowSolutionCardI = {
    iconVariant: 'dialog',
    title: this.t('tlc.churn_flow.steps.too_complicated.solutions.book_consultation.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.too_complicated.solutions.book_consultation.incentive_1'),
      this.t('tlc.churn_flow.steps.too_complicated.solutions.book_consultation.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.too_complicated.solutions.book_consultation.cta'),
  };

  public readonly joinTrainingSession: ChurnFlowSolutionCardI = {
    iconVariant: 'training',
    title: this.t('tlc.churn_flow.steps.too_complicated.solutions.join_training_session.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.too_complicated.solutions.join_training_session.incentive_1'),
      this.t('tlc.churn_flow.steps.too_complicated.solutions.join_training_session.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.too_complicated.solutions.join_training_session.cta'),
  };

  public readonly seeWhatsComing: ChurnFlowSolutionCardI = {
    iconVariant: 'roadmap',
    title: this.t('tlc.churn_flow.steps.too_complicated.solutions.see_whats_coming.title'),
    incentives: [
      this.t('tlc.churn_flow.steps.too_complicated.solutions.see_whats_coming.incentive_1'),
      this.t('tlc.churn_flow.steps.too_complicated.solutions.see_whats_coming.incentive_2'),
    ],
    ctaText: this.t('tlc.churn_flow.steps.too_complicated.solutions.see_whats_coming.cta'),
  };

  public bookConsultationAction(): void {
    this.openIntercom(
      this.t('tlc.churn_flow.steps.too_complicated.solutions.book_consultation.intercom_message'),
    );
  }
}
